<template lang="pug">
section.single
  Header
  .container
    header.row.mt-5.pb-4.border-bottom.border-secondary
      .col
        h1.title {{ page.title }}
    article
      .row.py-5
        .col
          p 特定商取引法に基づく表記
          dl
            .d-flex
              dt 販売業者
              dd Attack株式会社

            .d-flex
              dt 運営責任者
              dd 代表取締役　村上 篤志

            .d-flex
              dt 住所
              dd 〒141-0001<br>
                | 東京都品川区北品川五丁目５−１５大崎ブライトコア４階

            .d-flex
              dt 営業時間
              dd 9時〜18時（土日祝日除く。）

            .d-flex
              dt お問い合わせ
              dd お問い合わせは<a href="https://attack-inc.co.jp/contact/">こちら</a>から<br>
                | https://attack-inc.co.jp/contact/<br>
                |
                | ※ 電話でのお問い合わせは受け付けておりません。<br>
                | サポートはメールのみとなります。<br>
                | あらかじめご了承いただきますようお願い致します。<br>
                | 営業時間外のお問い合わせについては、翌営業日以降の対応となりますので、予めご了承下さい。

            .d-flex
              dt 連絡先
              dd info@attack-inc.co.jp

            .d-flex
              dt お申し込みの有効期限
              dd 特になし

            .d-flex
              dt 返品・キャンセル
              dd 本サービスの性質上、お客様のご都合による代金支払い後の返金・返品・キャンセル等は致しかねます。<br>
                | あらかじめ、有料サービスの内容・利用環境・対応機種及び各ソフトウェア・アプリケーションの利用環境・対応機種等をよくお確かめの上でお申込み願います。<br>
                | なお、本サービスの種類・品質・数量に関して、本サービスの利用契約の内容に適合しないものがある場合には、法令の定めに従って対応致します。

            .d-flex
              dt サービス料金・販売数量・条件
              dd <a href="https://attack-inc.co.jp/target-system/">こちら</a>をご確認ください（表示価格は税込）

            .d-flex
              dt サービス料金以外の必要料金
              dd サービス利用料金に加えて別途消費税が発生致します。<br>
                | クレジットカード決済時の手数料については、お客様のご負担となります。<br>
                | 銀行振込の場合には、振込手数料については、お客様のご負担となります。<br>
                | インターネットの接続料金、通信料金等は、お客様のご負担となります。それぞれの料金は、お客様がご利用のインターネットプロバイダ、携帯電話会社等にお問い合わせ下さい。

            .d-flex
              dt お支払い方法
              dd クレジットカード・銀行振込<br>
                 | ※ 銀行振込を希望される場合は、サポートまでメールでご連絡下さい

            .d-flex
              dt 役務の提供時期
              dd 当社の入金確認後、有料サービスの利用が可能となります。

            .d-flex
              dt 代金の支払時期
              dd クレジットカード決済の場合には、購入ボタンを押した後<br>
                | 銀行振り込みの場合には、購入ボタンを押した後3日以内
  Footer
</template>

<script>
const page = {
  id: 'commerce',
  title: '特定商取引に基づく表記'
}

export default {
  name: page.id,
  data () {
    return {
      mask: false,
      app: {
        name: process.env.VUE_APP_NAME
      },
      page: page
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="stylus">
dl
  dt
    min-width 15rem
</style>
